import * as Sentry from "@sentry/react";

if ((window as any).SENTRY_DSN !== "") {
  Sentry.init({
    dsn: (window as any).SENTRY_DSN,
    environment: (window as any).ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      /^http:\/\/127.0.0.1:5100\/api/,
      /^https:\/\/app.getroas.ai\/api/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event, hint) {
      const exn = hint.originalException as any;
      if ([400, 401, 404].includes(exn?.response?.status)) {
        return null;
      }
      return event;
    },
  });
}
